import { Action, PageType, State } from "../types";
import { handleAboutYourself } from "./handleAboutYourself";
import { handleConfirmMmp } from "./handleConfirmMmp";
import { handleImportantInformation } from "./handleImportantInformation";
import { handleIncomeAndExpenses } from "./handleIncomeAndExpenses";
import { handleLandingPage } from "./handleLandingPage";
import { handleNewCreditLimit } from "./handleNewCreditLimit";
import { handleNzForm } from "./handleNzForm";
import { handleOtp } from "./handleOtp";
import { handleProofOfIncome } from "./handleProofOfIncome";
import { handleReviewDetails } from "./handleReviewDetails";
import { handleVerifierTerms } from "./handleVerifierTerms";

export const reducer = (state: State, action: Action): State => {
  switch (state.page) {
    case PageType.LANDING: {
      return handleLandingPage(state, action);
    }

    case PageType.NZ_FORM: {
      return handleNzForm(state, action);
    }

    case PageType.OTP: {
      return handleOtp(state, action);
    }

    case PageType.NEW_CREDIT_LIMIT: {
      return handleNewCreditLimit(state, action);
    }

    case PageType.IMPORTANT_INFORMATION: {
      return handleImportantInformation(state, action);
    }

    case PageType.ABOUT_YOURSELF: {
      return handleAboutYourself(state, action);
    }

    case PageType.INCOME_AND_EXPENSES: {
      return handleIncomeAndExpenses(state, action);
    }

    case PageType.REVIEW_DETAILS: {
      return handleReviewDetails(state, action);
    }

    case PageType.VERIFIER_TERMS: {
      return handleVerifierTerms(state, action);
    }

    case PageType.CONFIRM_MMP: {
      return handleConfirmMmp(state, action);
    }
    case PageType.PROOF_OF_INCOME: {
      return handleProofOfIncome(state, action);
    }

    default: {
      return state;
    }
  }
};
